import React, { Component } from 'react';
import { Link } from "react-router-dom";

class FooterQuickLinkWidget extends Component {
    state = {
        title: 'Get to Know Us',
        links: [
            {
                path: '/',
                text: 'About Katika'
            },
            {
                path: '/',
                text: 'Group Economics'
            },
            {
                path: '/',
                text: 'Partners'
            },
            {
                path: '/',
                text: 'Careers'
            },
            {
                path: '/',
                text: 'Press'
            },
            {
                path: '/',
                text: 'Katika Lab'
            }
        ]
    }
    render() {
        return (
            <>
                <div className="col-lg-2 col-md-2 col-sm-2 column-td-6">
                    <div className="footer-item">
                        <h4 className="footer__title">
                            {this.state.title}
                        </h4>
                        <ul className="list-items">
                            {this.state.links.map((link, index) => {
                                return (
                                    <li key={index}>
                                        <Link to={link.path}>{link.text}</Link>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </>
        );
    }
}

export default FooterQuickLinkWidget;